import React, { useContext } from 'react';
import { Modal as ModalModule } from 'common';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const DeleteContactsModal = ({ data: { selectedContacts, deleteContacts }, modalId }) => {
	const { closeModal } = useContext(ModalContext);

	const onDeleteButtonClick = () => {
		deleteContacts();
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Yes',
		onClick: onDeleteButtonClick,
		dataqa: 'delete-contact-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-contact-no-button',
	};

	const renderText =
		selectedContacts.length === 1
			? 'Delete this contact?'
			: `Delete ${selectedContacts.length} contacts?`;

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-delete-modal warning-modal"
			header={`Delete Contact${selectedContacts.length > 1 ? 's' : ''}`}
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{renderText}</p>
			</div>
		</Modal>
	);
};

export default DeleteContactsModal;
